import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {

  state: () => ({
    loading: false,
    titulo_tela: "",
    drawer: {
      component: null,
      show: false,
      width: 400,
      right: true
    },
    resolve: null,
    reject: null,
    timeout: null,
    timer: null,
  }),

  actions: {
    setLoading(loading) {
      this.loading = loading;
    },

    setTitulo(titulo) {
      this.titulo_tela = titulo;
    },

    openDrawer(drawer = {}) {
      this.drawer = {
        ...this.drawer,
        ...drawer,
        show: true,
      };

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    closeDrawer() {
      this.drawer.show = false;
      this.resolve(true);
    },

    startTimerout(mensagem, tempo = 5000) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.timeout = null;
      }, tempo);
    },

    startTimer(tempo = 1000) {
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.timer = null;
      }, tempo);
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    
  }

})
